import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CarryOutOutlinedSvg from "@ant-design/icons-svg/es/asn/CarryOutOutlined";
import AntdIcon from "../components/AntdIcon";
var CarryOutOutlined = function CarryOutOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CarryOutOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  CarryOutOutlined.displayName = 'CarryOutOutlined';
}
export default /*#__PURE__*/React.forwardRef(CarryOutOutlined);